import {RouteProps} from 'config/navigation';
import {MdCreditCard} from 'react-icons/md';
import CouponRedemptions from './coupon-redemptions';

const couponredemptionsPages: RouteProps = {
  name: 'Cupons',
  path: 'coupon-redemptions',
  permission: 'couponRedemptions.findAll',
  icon: <MdCreditCard />,
  subRoutes: [
    {
      path: '',
      element: <CouponRedemptions />,
      permissions: ['couponRedemptions.findAll'],
    },
  ],
};

export default couponredemptionsPages;
